export default function PriceRange({ value, onChange }) {
  return (
    <div className="border-b border-border/60 py-5">
      <h3 className="mb-3 text-sm font-semibold tracking-tight text-foreground">
        Price
      </h3>

      <div className="grid grid-cols-2 gap-3">
        <input
          type="number"
          placeholder="Min"
          value={value.min}
          onChange={(event) => onChange({ ...value, min: event.target.value })}
          className="rounded-xl border border-border bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        />
        <input
          type="number"
          placeholder="Max"
          value={value.max}
          onChange={(event) => onChange({ ...value, max: event.target.value })}
          className="rounded-xl border border-border bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        />
      </div>
    </div>
  );
}